import { render } from "./ReviewMode.vue?vue&type=template&id=5e4e3ae8"
import script from "./ReviewMode.vue?vue&type=script&lang=js"
export * from "./ReviewMode.vue?vue&type=script&lang=js"

import "./ReviewMode.vue?vue&type=style&index=0&id=5e4e3ae8&global=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/review/ReviewMode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e4e3ae8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e4e3ae8', __exports__)) {
    api.reload('5e4e3ae8', __exports__)
  }
  
  module.hot.accept("./ReviewMode.vue?vue&type=template&id=5e4e3ae8", () => {
    api.rerender('5e4e3ae8', render)
  })

}


export default __exports__